import IframeActivity from "./IframeActivity";

export default function SmallTalk() {
    return (
        <IframeActivity
            src="/activities/small-talk/index.html"
            title="Small Talk"
        />
    );
}